import { render } from "./ComponentTree.vue?vue&type=template&id=f1cd10ae"
import script from "./ComponentTree.vue?vue&type=script&lang=ts"
export * from "./ComponentTree.vue?vue&type=script&lang=ts"
script.render = render

export default script